import { RouterProvider } from "react-router-dom";
import router from "./router";

const AppRouter = () => <RouterProvider router={router} />;

export default AppRouter;
